import isEqual from 'lodash/isEqual'
import dayjs from 'dayjs'
import { Dialog } from '@mui/material'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { displayNamesOfEventTypes } from 'src/consumer/constants'
import MentorPastEventsListing from 'src/mentor/components/MentorEventsPage/components/bookingListing/MentorPastEventsListing'
import ClinicScreeningFallbackDetails from 'src/mentor/components/MentorEventsPage/components/eventsListing/ClinicScreeningFallbackDetails'
import EventTypeCreationForm from 'src/mentor/components/MentorEventsPage/components/eventsListing/EventTypeCreationForm'
import EventTypeFormDrawer from 'src/mentor/components/MentorEventsPage/components/eventsListing/EventTypeFormDrawer'
import TherapistEventsListing from 'src/mentor/components/MentorEventsPage/components/eventsListing/TherapistEventsListing'
import { buildEffectiveClinicScreeningFallbacks } from 'src/mentor/components/MentorEventsPage/components/utils'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { getClinicBrandIdFromClinicId } from 'src/mentor/helpers/utilityFunctions'
import { MentorClinicsContext } from 'src/mentor/layout'
import { postMPData } from 'src/mentor/services'
import {
  AvailabilityPageContainer,
  PageContentOneContainer,
  PageDescriptionText,
  PageHeadlineComponent,
  PageMainContentContainer,
  PageMainContentPartThree,
  UnderlineActiveButtons,
} from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import { getAllBundlePacksForCurrentMentor, getAllOneOnOnePlans } from './MentorEventsHelpers'

export default function MentorEventsPage() {
  const clinicsContext = useContext(MentorClinicsContext) || {}
  const { clinicEventTypesMap } = clinicsContext
  const { mentorProfileData, updateProfileData, mentorClinicAssociationData } =
    useContext(MentorProfileContext)
  const [selectedView, setSelectedView] = useState('viewScheduledEvents') // viewAllEvents, viewScheduledEvents
  const [eventTypes, setEventTypes] = useState(null)
  const [eventFormModalOpen, setEventFormModalOpen] = useState(false)
  const [eventFormModalData, setEventFormModalData] = useState(null)
  const [mentorBookedSlotsData, setMentorBookedSlotsData] = useState([])
  const [mentorBookedSlotsLoading, setMentorBookedSlotsLoading] = useState()
  const [currentTime, setCurrentTime] = useState(dayjs().format('YYYY-MM-DD HH:mm:ss'))
  const [oneOnOnePlans, setOneOnOnePlans] = useState([])
  const [bundlePacks, setBundlePacks] = useState([])
  const [selectedClinicFallback, setSelectedClinicFallback] = useState(null)

  const navigate = useNavigate()
  const urlParams = new URLSearchParams(window.location.search)

  const [hasNextPage, setHasNextPage] = useState(true)
  const [pageNumber, setPageNumber] = useState(0)

  const canEditEvents = false

  // // EVENT TYPES RELATED:
  async function updateEventTypes() {
    const response = await postMPData(
      '/api/secure/teacher/update/events',
      eventTypes?.map((type) => ({ ...type, apiParam: 'event-type' })),
    )
    if (response?.status === 200) {
      // console.log("Updated your events")
    }
  }

  async function updateEventAndGetProfile() {
    await updateEventTypes()
    await updateProfileData()
  }

  useEffect(() => {
    let eventTypes = mentorProfileData?.eventTypes
    if (!Array?.isArray(eventTypes)) {
      eventTypes = []
    }
    setEventTypes(eventTypes)
  }, [mentorProfileData])

  useEffect(() => {
    if (urlParams?.has('view') && urlParams.get('view') === 'booked') {
      setSelectedView('viewScheduledEvents')
    }
  }, [])

  const handleEventCreation = (data) => {
    if (data?.contextId) {
      data.clinicBrandId = getClinicBrandIdFromClinicId(
        mentorClinicAssociationData,
        data?.contextId,
      )
    } else {
      data.clinicBrandId = ''
    }
    if (data?.uid) {
      let indexOfEvent
      eventTypes?.forEach((item, index) => {
        if (data.uid === item.uid) {
          indexOfEvent = index
        }
      })

      setEventTypes((prev) => {
        const tempData = [...prev]
        tempData[indexOfEvent] = data
        return tempData
      })
    } else {
      const newEvent = {
        ...data,
      }
      setEventTypes((prev) => [...prev, newEvent])
    }

    setEventFormModalOpen(false)
    setEventFormModalData(null)
  }

  useEffect(() => {
    if (
      Boolean(eventTypes) &&
      eventTypes?.length !== 0 &&
      !isEqual(mentorProfileData?.eventTypes, eventTypes)
    ) {
      updateEventAndGetProfile()
    }
  }, [eventTypes])

  // // BOOKED SLOTS RELATED:
  async function getOneOnOnePlans() {
    const oneOnOnePlans = await getAllOneOnOnePlans()
    if (oneOnOnePlans) {
      setOneOnOnePlans(oneOnOnePlans)
    }
  }
  async function getBundlePackPlans() {
    const bundlePacks = await getAllBundlePacksForCurrentMentor(mentorProfileData?.id)
    if (bundlePacks) {
      setBundlePacks(bundlePacks)
    }
  }

  function cleanExistingData() {
    setMentorBookedSlotsData([])
    // setBookedSessionsFirstPage()
    setPageNumber(0)
  }

  useEffect(() => {
    cleanExistingData()
    const intervalId = setInterval(() => {
      cleanExistingData()
    }, 120000)
    return () => {
      clearInterval(intervalId)
    }
  }, []) // call every 120 seconds

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs().format('YYYY-MM-DD HH:mm:ss'))
    }, 60000)

    return () => clearInterval(interval)
  }, []) //setting time every minute

  // async function getAndSetBookedSlots() {
  //   setMentorBookedSlotsLoading(true)
  //   const bookedSlots = await getMentorBookedSlots(setMentorBookedSlotsLoading)
  //   if (bookedSlots) {
  //     setMentorBookedSlotsData(bookedSlots)
  //   }
  // }

  useEffect(() => {
    getOneOnOnePlans()
    getBundlePackPlans()
    // setBookedSessionsFirstPage()
  }, [])

  const closeEventTypeDrawer = useCallback(() => {
    setEventFormModalOpen(false)
    setEventFormModalData(null)
  }, [])

  const setEventFormModalOpenSafe = useCallback(
    (open) => {
      if (open === false) {
        closeEventTypeDrawer()
      } else {
        setEventFormModalOpen(true)
      }
    },
    [closeEventTypeDrawer],
  )

  const eventTypeDrawerTitle = !canEditEvents
    ? 'View event type'
    : eventFormModalData
      ? 'Edit event type'
      : 'New event type'

  const eventTypeDrawerSubtitle = !canEditEvents
    ? 'Review how this session is configured. Editing is disabled for your role.'
    : 'Configure session details, pricing, buffers, location, and clinic association. Changes save to your mentor profile.'

  const effectiveClinicScreeningEntries = useMemo(
    () =>
      buildEffectiveClinicScreeningFallbacks({
        mentorEventTypes: mentorProfileData?.eventTypes,
        associatedClinics: mentorClinicAssociationData,
        clinicAppointmentTypesMap: clinicEventTypesMap,
      }),
    [clinicEventTypesMap, mentorClinicAssociationData, mentorProfileData?.eventTypes],
  )

  return (
    <AvailabilityPageContainer>
      <PageHeadlineComponent heading="Set your events" />

      <PageContentOneContainer>
        <PageDescriptionText>
          Add new events, edit existing ones, or find scheduled events
        </PageDescriptionText>
      </PageContentOneContainer>

      <PageMainContentContainer>
        <PageMainContentPartThree style={{ border: '1px solid #CCCCCC' }}>
          <UnderlineActiveButtons
            active={selectedView === 'viewAllEvents'}
            onClick={() => setSelectedView('viewAllEvents')}
          >
            Event Types
          </UnderlineActiveButtons>
          <UnderlineActiveButtons
            active={selectedView === 'viewScheduledEvents'}
            onClick={() => setSelectedView('viewScheduledEvents')}
          >
            All Booked Events
          </UnderlineActiveButtons>
        </PageMainContentPartThree>

        {selectedView === 'viewAllEvents' && (
          <>
            <TherapistEventsListing
              effectiveClinicScreeningEntries={effectiveClinicScreeningEntries}
              mentorEventTypes={mentorProfileData?.eventTypes}
              associatedClinics={mentorClinicAssociationData}
              mentorSlug={mentorProfileData?.slug}
              onClickNewEventType={() => {
                setEventFormModalData(null)
                setEventFormModalOpen(true)
              }}
              onClickExistingEventType={(item) => {
                setEventFormModalOpen(true)
                setEventFormModalData(item)
              }}
              onClickClinicFallback={setSelectedClinicFallback}
              disableEventCreation={!canEditEvents}
            />
          </>
        )}

        {selectedView === 'viewScheduledEvents' && (
          <>
            <MentorPastEventsListing
              logsApiEndpoint="/api/secure/teacher/booked-event-info/logs/get"
            />
            {/* <MentorUpcomingPastEventsTable
              allEvents={mentorBookedSlotsData}
              loadingSlots={mentorBookedSlotsLoading}
              mentorProfileData={mentorProfileData}
              onClickJoin={(item) => navigate(`/l/${item?.slug}`)}
              refreshEvents={() => {
                cleanExistingData()
              }}
            /> */}
            {/* <SentryRefHandler hasNextPage={hasNextPage} sentryRef={sentryRef} /> */}
          </>
        )}
      </PageMainContentContainer>

      <EventTypeFormDrawer
        open={eventFormModalOpen}
        onClose={closeEventTypeDrawer}
        title={eventTypeDrawerTitle}
        subtitle={eventTypeDrawerSubtitle}
      >
        {eventFormModalOpen && (
          <EventTypeCreationForm
            key={eventFormModalData?.uid || eventFormModalData?.id || 'new-event-type'}
            eventFormModalData={eventFormModalData}
            setEventFormModalOpen={setEventFormModalOpenSafe}
            displayNamesOfEventTypes={displayNamesOfEventTypes}
            handleEventCreation={handleEventCreation}
            oneOnOnePlans={oneOnOnePlans}
            bundlePacks={bundlePacks}
            refreshBundlePacks={getBundlePackPlans}
            refreshOneOnOnePlans={getOneOnOnePlans}
            mentorClinicAssociationData={mentorClinicAssociationData}
            mentorProfileData={mentorProfileData}
            isDisabled={!canEditEvents}
            layout="drawer"
          />
        )}
      </EventTypeFormDrawer>
      <Dialog open={Boolean(selectedClinicFallback)} onClose={() => setSelectedClinicFallback(null)}>
        <ClinicScreeningFallbackDetails
          fallbackEntry={selectedClinicFallback}
          onClose={() => setSelectedClinicFallback(null)}
        />
      </Dialog>
    </AvailabilityPageContainer>
  )
}
